// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableCellMailEquipe_color__2kLFc {\n  color: #d32f2f;\n}\n.TableCellMailEquipe_mobile__30jws {\n  margin-top: 5px;\n}\n.TableCellMailEquipe_desktop__3apAO {\n  top: 3px;\n  cursor: pointer;\n  position: relative;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Table/TableCellMailEquipe.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".color {\n  color: #d32f2f;\n}\n.mobile {\n  margin-top: 5px;\n}\n.desktop {\n  top: 3px;\n  cursor: pointer;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": "TableCellMailEquipe_color__2kLFc",
	"mobile": "TableCellMailEquipe_mobile__30jws",
	"desktop": "TableCellMailEquipe_desktop__3apAO"
};
export default ___CSS_LOADER_EXPORT___;
